// ترجماتُ المجموعة 1 — تُملأ بترجمة صفحاتها (2026-10-03). المفتاح: النصُّ العربيّ كما في tt().
const EN_B1: Record<string, string> = {
  "قبل لحظات": "Moments ago",
  "قبل {n} دقيقة": "{n} min ago",
  "قبل {n} ساعة": "{n} h ago",
  "عدد السجلات: {n}": "Records: {n}",
  "الاتصال يعمل": "Connection works",
  "فشل الاختبار": "Test failed",
  "تعذّر الاختبار": "Could not run test",
  "مزامنة تعمل بالفعل": "Sync already running",
  "انتظر انتهاءها ثم أعد المحاولة": "Wait for it to finish, then try again",
  "تم بدء مزامنة {name}": "{name} sync started",
  "تعمل بالخلفية — حدّث الصفحة بعد دقائق": "Running in the background — refresh the page in a few minutes",
  "تعذّر بدء المزامنة": "Could not start sync",
  "حالة كل الربطات الخارجية — اختبار واتصال ومزامنة من مكان واحد": "Status of all external connections — test and sync from one place",
  "متصل": "Connected",
  "آخر مزامنة:": "Last sync:",
  "آخر خطأ:": "Last error:",
  "جاري الاختبار…": "Testing…",
  "اختبار الاتصال": "Test connection",
  "جاري…": "Working…",
  "إعادة مزامنة": "Resync",
  "إعداد اتصالات Drive8 وERP يتم من لوحة الماستر (تكامل الشركات)، وإدارة حسابات القنوات من الإعدادات ← القنوات والحسابات.": "Drive8 and ERP connections are configured from the Master panel (company integrations); channel accounts are managed in Settings → Channels & Accounts.",
  "يظهر {n} من {total} تبويبات": "Showing {n} of {total} tabs",
  "تظهر {n} من {total} صفحة": "Showing {n} of {total} pages",
  "معاينة حيّة": "Live preview",
  "كما يراها {name}": "As {name} sees it",
  "كمبيوتر": "Desktop",
  "هاتف": "Phone",
  "{n} استثناءات عن الدور": "{n} overrides from role",
  "مطابق للدور": "Matches role",
  "حسابي": "My Account",
  "محمد العنزي": "Mohammed Al-Enezi",
  "سارة الكندري": "Sara Al-Kandari",
  "بدر المطيري": "Bader Al-Mutairi",
  "السلام عليكم، بغيت أجدد العقد…": "Hello, I'd like to renew my contract…",
  "تم استلام السيارة، شكراً لكم": "Car received, thank you",
  "كم سعر تأجير اليوم الواحد؟": "What's the daily rental rate?",
  "الموظّف": "Employee",
  "لا تتوفر صفحات أخرى — بحسب الصلاحيات الحالية": "No other pages available — based on current permissions",
  "رحلاتي": "My Trips",
  "التتبع": "Tracking",
  "العملاء": "Customers",
  "الدفع": "Payments",
  "الحضور": "Attendance",
  "فيديو العقود": "Contract Videos",
  "المعاملات": "Errands",
  "جسر": "Jisr",
  "لا صفحات متاحة بهذه الصلاحيات": "No pages available with these permissions",
  "الصفحة الرئيسية": "Home",
  "المعاينة تعكس الصلاحيات قبل الحفظ. مميزات الشركة المطفأة من الماستر وربط ملف الحضور قد تُخفي عناصر إضافية.": "The preview reflects permissions before saving. Company features disabled by the master and attendance-profile linking may hide additional items.",
  "دعم فني": "Technical support",
  "الحجز": "Booking",
  "تأكيد السعر": "Price confirmation",
  "إرسال الموقع": "Send location",
  "طلب البطاقة المدنية": "Civil ID request",
  "رابط الدفع": "Payment link",
  "تذكير التسليم": "Delivery reminder",
  "تذكير الإرجاع": "Return reminder",
  "صيانة أو تأخير": "Maintenance or delay",
  "اعتماد": "Approve",
  "تم الاعتماد — صار متاحاً في الردود السريعة": "Approved — now available in quick replies",
  "سيُحفظ في": "Will be saved to",
  "معتمدة": "Approved",
  "ملاحظات داخلية": "Internal notes",
  "القوالب هنا لا تظهر في الردود السريعة حتى يعتمدها المدير.": "Templates here don't appear in quick replies until a manager approves them.",
  "هل أنت متأكد من حذف هذا القالب؟": "Are you sure you want to delete this template?",
  "تم الحذف بنجاح": "Deleted successfully",
  "سيظهر في «قيد المراجعة» حتى يعتمده المدير": "It will appear under \"Under review\" until a manager approves it",
  "تم التحديث بنجاح": "Updated successfully",
  "تمت الإضافة بنجاح": "Added successfully",
  "إدارة القوالب": "Template Management",
  "تخصيص قوالب الردود السريعة والرسائل التلقائية": "Customize quick-reply templates and automated messages",
  "قالب جديد": "New template",
  "الاستخدام: {n} مرة": "Used {n} times",
  "المتغيرات:": "Variables:",
  "لا توجد قوالب في هذا القسم": "No templates in this section",
  "تعديل القالب": "Edit template",
  "إضافة قالب جديد": "Add new template",
  "اسم القالب": "Template name",
  "مثال: رسالة ترحيبية": "e.g. Welcome message",
  "الفئة": "Category",
  "اختر الفئة": "Select category",
  "المحتوى": "Content",
  "استخدم {{متغير}} لإضافة متغيرات": "Use {{variable}} to add variables",
  "أهلاً {{name}}، كيف يمكننا مساعدتك اليوم؟": "Hi {{name}}, how can we help you today?",
  "حفظ القالب": "Save template",
  "آخر 7 أيام": "Last 7 days",
  "🚗 العقود المؤجرة": "🚗 Rented contracts",
  "✅ العقود المستلمة": "✅ Returned contracts",
  "💰 الدفعات المقبوضة": "💰 Receipts collected",
  "💸 الصرف المدفوع": "💸 Expenses paid",
  "المدة": "Duration",
  "قيمة العقد": "Contract value",
  "رقم السند": "Voucher #",
  "فشل التصدير": "Export failed",
  "العقود المؤجرة والمستلمة والدفعات والصرف خلال فترة — مع تصدير PDF": "Rented and returned contracts, receipts and expenses over a period — with PDF export",
  "PDF شامل (الأقسام الأربعة)": "Full PDF (all four sections)",
  "Excel شامل": "Full Excel",
  "عقود مؤجرة": "Rented contracts",
  "قيمة المؤجرة (د.ك)": "Rented value (KWD)",
  "عقود مستلمة": "Returned contracts",
  "المقبوض (د.ك)": "Collected (KWD)",
  "الصرف (د.ك)": "Expenses (KWD)",
  "مطابقة ERP": "ERP reconciliation",
  "PDF هذا القسم": "PDF of this section",
  "لا توجد سجلات في هذه الفترة لهذا القسم.": "No records in this period for this section.",
  "مطابق": "Matched",
  "ناقص": "Short",
  "زيادة": "Excess",
  "تعذر بدء المزامنة": "Could not start sync",
  "تعذر الاتصال بـ ERP": "Could not connect to ERP",
  "{n} يوم فيه حركة": "{n} days with activity",
  "{n} يوم فيه فرق": "{n} days with a difference",
  "كلها مطابقة ✓": "All matched ✓",
  "آخر مزامنة ERP:": "Last ERP sync:",
  "آخر مزامنة Drive8:": "Last Drive8 sync:",
  "أيام الفروقات فقط": "Days with differences only",
  "مزامنة ERP الآن": "Sync ERP now",
  "PDF المطابقة": "Reconciliation PDF",
  "لا توجد حركة في هذه الفترة — أو كل الأيام مطابقة (شيل فلتر الفروقات).": "No activity in this period — or all days match (clear the differences filter).",
  "قبض Drive8": "Drive8 receipts",
  "قبض ERP": "ERP receipts",
  "حالة القبض": "Receipts status",
  "صرف Drive8": "Drive8 expenses",
  "صرف ERP": "ERP expenses",
  "حالة الصرف": "Expenses status",
  "سندات Drive8": "Drive8 vouchers",
  "سند": "Voucher",
  "قيود ERP": "ERP entries",
  "قيد": "Entry",
  "لا توجد أي قيود في ERP لهذا اليوم": "No ERP entries for this day",
  "الأحد": "Sunday",
  "الاثنين": "Monday",
  "الثلاثاء": "Tuesday",
  "الأربعاء": "Wednesday",
  "الخميس": "Thursday",
  "الجمعة": "Friday",
  "السبت": "Saturday",
  "إجازة": "Day off",
  "من يداوم يبدأ {t}": "those working start at {t}",
  "بلا أيّام إجازة — دوام الموظّف كلَّ الأيّام": "No days off — employee works every day",
  "عرض الصورة": "View photo",
  "حضور": "Check-in",
  "صورة الحضور": "Check-in photo",
  "استئذان ساعات": "Hourly permission",
  "إجازة أيّام": "Days leave",
  "قيد الموافقة": "Pending approval",
  "موافَق عليه": "Approved",
  "مرفوض": "Rejected",
  "سحبه الموظّف": "Withdrawn by employee",
  "معتمد": "Approved",
  "لوحة الحضور": "Attendance Dashboard",
  "الموظفون": "Employees",
  "الاستئذان": "Leave",
  "الرواتب": "Payroll",
  "تعذّر تحميل صلاحياتك": "Couldn't load your permissions",
  "لا يمكن عرض بيانات الموظفين قبل التحقّق من صلاحيتك. لم يُمنع شيء ولم يُفتح شيء.": "Employee data can't be shown until your permissions are verified. Nothing was denied or granted.",
  "إعادة المحاولة": "Retry",
  "وإن تكرّر: راجع إدارة شركتك.": "If it keeps happening, contact your company's admin.",
  "اذهب إلى «تسجيل حضوري» ←": "Go to \"My Check-in\" →",
  "ليس لديك صلاحية الاطلاع على بيانات الموظفين الآخرين.": "You don't have permission to view other employees' data.",
  "اطلب من مدير النظام منحك «حضور الموظفين الآخرين» أو «رواتب الموظفين».": "Ask your system admin to grant you \"Other employees' attendance\" or \"Employee payroll\".",
  "تعذّر تحميل صلاحياتك — أُخفيت شاشاتُ بيانات الموظفين حتى يتم التحقّق. لم يُمنح شيء ولم يُسحب.": "Couldn't load your permissions — employee data screens are hidden until verified. Nothing was granted or revoked.",
  "مُصفّى": "Filtered",
  "اضغط لإلغاء التصفية": "Click to clear filter",
  "اضغط لعرض هذه الجماعة": "Click to show this group",
  "تعذّر الاتصال بالخادم": "Couldn't connect to the server",
  "التأخير {a}د ← {b}د": "Lateness {a}m → {b}m",
  "لم يتغيّر ({n}د)": "Unchanged ({n}m)",
  "بداية الدوام المخزَّنة {t} — صحّحها في «الموظفون» ثمّ أعِد الاحتساب.": "Stored shift start is {t} — correct it under \"Employees\", then recalculate.",
  "تعذّر إعادة الاحتساب": "Couldn't recalculate",
  "تعذّر التحديث": "Couldn't update",
  "سُجّل الانصراف": "Check-out recorded",
  "تعذّر التسجيل": "Couldn't record",
  "تعذّر التصدير": "Export failed",
  "إجمالي الموظفين": "Total employees",
  "الموظّفون النشطون غيرُ المعفَين من البصم": "Active employees not exempt from check-in",
  "في الفرع المختار": "in the selected branch",
  "عددُ أشخاصٍ لا سجلّات، فلا يفتح جدولَ السجلّات": "a count of people, not records, so it doesn't open the records table",
  "حاضرون": "Present",
  "سجلّاتٌ حالتُها «معتمد» — ومن بصم فعلاً: {n} موظّف": "Records with status \"Approved\" — employees who actually checked in: {n}",
  "لم يسجّلوا حضوراً": "Not checked in",
  "لا سجلَّ لهم اليوم، بعد استثناء يوم الراحة والإذن المعتمَد. وليس حكمَ غيابٍ ماليّاً — ذاك تقرّره الرواتب": "No record today, excluding rest days and approved leave. Not a payroll absence ruling — payroll decides that",
  "متأخّرون": "Late",
  "سجلّاتٌ تأخيرُها أكبرُ من صفر": "Records with lateness above zero",
  "بلا بصمة انصراف": "No check-out",
  "بصمةٌ مضت مهلتُها بلا خروج (حكمُ الخادم) — لن تُحتسب حضوراً حتى يسجّل المديرُ انصرافَها": "Check-in past its time limit with no check-out (server ruling) — won't count as attendance until a manager records the check-out",
  "إجازة رسميّة": "Day off",
  "يومُهم راحةٌ في جدول فرعهم الأسبوعيّ": "Their rest day in the branch's weekly schedule",
  "بإذن معتمَد": "Approved leave",
  "أجازهم مشرفٌ باستئذانٍ معتمَدٍ يغطّي هذا اليوم": "Excused by a supervisor with approved leave covering this day",
  "نسبة الحضور": "Attendance rate",
  "وليست نسبةَ أشخاص: من له بصمتان معتمَدتان يُعَدّ مرّتين، والخادمُ يسقّفها عند ١٠٠٪": "not a share of people: someone with two approved check-ins counts twice, and the server caps it at 100%",
  "لا مطلوبَ حضورُهم اليوم": "No one expected today",
  "{p} سجلّ معتمَد ÷ {e} مطلوب": "{p} approved records ÷ {e} expected",
  "تاريخ اليوم المعروض": "Displayed date",
  "الفرع": "Branch",
  "تصفية بالفرع": "Filter by branch",
  "كل الفروع": "All branches",
  "تصفية بحالة السجلّ": "Filter by record status",
  "كل الحالات": "All statuses",
  "بحث بالاسم أو الرمز": "Search by name or code",
  "موظّف": "employee",
  "سجلّ": "record",
  "طلب": "request",
  "بالداخل الآن": "In now",
  "بصمة انصراف ناقصة — تحتاج مراجعة": "Missing check-out — needs review",
  "مكتملة": "Complete",
  "بصمة انصراف ناقصة": "Missing check-out",
  "بانتظار المراجعة": "Awaiting review",
  "استئذان معلّق": "Pending leave",
  "تأخير {n}د": "Late {n}m",
  "اكتب اسماً أو رمزاً…": "Type a name or code…",
  "بحث بالاسم أو الرمز الوظيفيّ": "Search by name or employee code",
  "إلغاء التصفية": "Clear filters",
  "جارٍ التحديث…": "Refreshing…",
  "آخرُ تحديثٍ ناجحٍ لكلّ المصادر:": "Last successful refresh of all sources:",
  "تحديثٌ جزئيّ — السجلّاتُ طازجةٌ وطلباتُ الاستئذان غيرُ مصرَّحٍ بقراءتها.": "Partial refresh — records are current, but you aren't permitted to read leave requests.",
  "تحديثٌ جزئيّ — السجلّاتُ طازجةٌ وطلباتُ الاستئذان تعذّرت قراءتُها.": "Partial refresh — records are current, but leave requests couldn't be read.",
  "المعروضُ أدناه قديم": "the data below is stale",
  "ليس لديك صلاحية قراءة هذه البيانات.": "You don't have permission to read this data.",
  "بلغ الجوابُ حدَّ {n} سجلّاً — ضيّق بالفرع أو الحالة؛ الأرقامُ المحسوبةُ من الجدول قد تكون ناقصة.": "The response hit the {n}-record limit — narrow by branch or status; numbers computed from the table may be incomplete.",
  "يحتاج متابعة": "Needs follow-up",
  "{n} بندًا": "{n} items",
  "جارٍ": "Loading",
  "لا شيء": "None",
  "النطاق:": "Scope:",
  "بحث «{q}»": "search \"{q}\"",
  "فلترُ حالة السجلّ («{s}») يسري على السجلّات وحدَها — لا على طلبات الاستئذان.": "The record status filter (\"{s}\") applies to records only — not to leave requests.",
  "جارٍ قراءة السجلّات وطلبات الاستئذان…": "Reading records and leave requests…",
  "طلباتُ الاستئذان غيرُ مقروءةٍ لك — ليست لديك صلاحيتُها. المعروضُ أدناه من السجلّات وحدَها، وقد يكون ثمّة طلبٌ ينتظر لا تراه.": "You can't read leave requests — you don't have that permission. What's shown below comes from records only, and there may be a pending request you can't see.",
  "تعذّرت قراءةُ طلبات الاستئذان": "Couldn't read leave requests",
  "فلا يُقال «لا شيءَ ينتظر». المعروضُ أدناه من السجلّات وحدَها.": "so we can't say \"nothing is pending\". What's shown below comes from records only.",
  "أعد قراءة الطلبات": "Reload requests",
  "لا سجلَّ يحتاج مراجعةً ولا استئذانَ معلّقٌ يمسّ هذا اليوم في هذا النطاق.": "No records need review and no pending leave touches this day in this scope.",
  "وقائمةُ الطلبات بلغت حدَّ {n} صفّاً، فقد يكون ثمّة معلّقٌ خارجها.": "The request list hit the {n}-row limit, so there may be pending items beyond it.",
  "(البصمةُ المفتوحةُ الآن لا تُنشئ بنداً — وهي ليست نقصاً.)": "(A check-in that's open right now doesn't create an item — it isn't missing anything.)",
  "افتح «الاستئذان»": "Open \"Leave\"",
  "يقرّره مشرفٌ من تبويب «الاستئذان»": "A supervisor decides this from the \"Leave\" tab",
  "تسجيل الانصراف": "Record check-out",
  "تصحيحُ الانصراف لمديرٍ أو مشرف": "Check-out corrections are for a manager or supervisor",
  "المعروض الآن:": "Showing now:",
  "لم يسجّلوا حضوراً ({n} موظّف)": "Not checked in ({n} employees)",
  "المتأخّرون ({n} سجلّ)": "Late ({n} records)",
  "بلا بصمة انصراف ({n} سجلّ)": "No check-out ({n} records)",
  "الحالة:": "Status:",
  "الفرع:": "Branch:",
  "بحث:": "Search:",
  "البحث «{q}»": "the search \"{q}\"",
  "فلترُ الحالة": "the status filter",
  "{x} يضيّقه": "narrowed by {x}",
  " و": " and ",
  "البطاقةُ تعدّ {n} في اليوم/الفرع · المعروض {m}": "The card counts {n} for the day/branch · showing {m}",
  "الصورة": "Photo",
  "الموظف": "Employee",
  "ساعات": "Hours",
  "تأخير": "Late",
  "إجراء": "Action",
  "غائب": "Absent",
  "لا غائبَ في هذا اليوم — الجميعُ سجّلوا دخولهم.": "No absentees today — everyone checked in.",
  "خروجٌ كتبه النظام عند السقف القديم — لم يعد يقع": "Check-out written by the system at the old cap — no longer happens",
  "تلقائي": "Auto",
  "مضت المهلةُ بلا خروج — لا تُحتسب حضوراً. سجّل الانصرافَ من زرّ الساعة.": "Time limit passed with no check-out — doesn't count as attendance. Record the check-out from the clock button.",
  "بلا خروج · غياب": "No check-out · Absent",
  "ما زال مسجَّلاً بالداخل": "Still checked in",
  "بالداخل": "Inside",
  "تأخيرٌ غيرُ معقول — الأرجح أنّ «بداية الدوام» في ملفّ الموظّف مكتوبةٌ صباحاً وهي مساءً. صحّحها من تبويب «الموظفون».": "Implausible lateness — the employee's \"shift start\" is most likely entered as AM instead of PM. Fix it in the \"Employees\" tab.",
  "{n}د": "{n} min",
  "{n}م": "{n} m",
  "موقع تسجيل الدخول على الخريطة": "Check-in location on the map",
  "موقع تسجيل الانصراف على الخريطة": "Check-out location on the map",
  "عرض تفاصيل سجلّ {name}": "View {name}'s record details",
  "اعتماد سجلّ {name}": "Approve {name}'s record",
  "رفض سجلّ {name}": "Reject {name}'s record",
  "رفض": "Reject",
  "تسجيل انصرافٍ منسيّ لسجلّ {name}": "Record a forgotten check-out for {name}",
  "يُكتب بسببٍ إلزاميٍّ في سجلّ التعديلات": "Logged with a required reason in the change log",
  "إعادة احتساب تأخير {name}": "Recalculate lateness for {name}",
  "يُعاد من «بداية الدوام» المخزَّنة حالياً في ملفّ الموظّف": "Recalculated from the \"shift start\" currently stored on the employee's profile",
  "إعادة احتساب التأخير": "Recalculate lateness",
  "عرضٌ فقط — التعديل لمديرٍ أو مشرف": "View only — editing is for a manager or supervisor",
  "ليس لديك صلاحية الاطلاع على سجلّات الحضور.": "You don't have permission to view attendance records.",
  "تعذّر تحميل السجلّات": "Couldn't load records",
  "لا سجلَّ يطابق التصفية الحالية.": "No records match the current filters.",
  "لا توجد سجلات لهذا اليوم": "No records for this day",
  "تفاصيل السجلّ": "Record details",
  "الرمز": "Code",
  "بلا فرع": "No branch",
  "دورة البصمة": "Check-in lifecycle",
  "الدخول": "Check-in",
  "الخروج": "Check-out",
  "كتبه النظام": "Written by system",
  "ساعات العمل": "Work hours",
  "التأخير": "Lateness",
  "حالة الموقع": "Location status",
  "بُعد الدخول": "Check-in distance",
  "مضت المهلةُ بلا بصمة انصراف، فهذا اليومُ لا يُحتسب حضوراً في الرواتب حتى يسجّل مديرٌ أو مشرفٌ الانصرافَ بسببٍ مكتوب.": "The time limit passed without a check-out, so this day does not count as attendance in payroll until a manager or supervisor records the check-out with a written reason.",
  "الموظّفُ ما زال مسجَّلاً بالداخل — حالةٌ طبيعيّةٌ لا تحتاج تدخّلاً حتى تمضي المهلة.": "The employee is still checked in — normal, no action needed until the time limit passes.",
  "عرضٌ فقط — اعتمادُ السجلّ وتصحيحُ الانصراف لمديرٍ أو مشرف.": "View only — approving records and correcting check-outs is for a manager or supervisor.",
  "تسجيل انصرافٍ منسيّ": "Record forgotten check-out",
  "دخل": "In at",
  "وقت الانصراف الفعليّ": "Actual check-out time",
  "السبب (إلزاميّ)": "Reason (required)",
  "نسي تسجيل الانصراف — أكّد المشرف مغادرته الساعة…": "Forgot to check out — supervisor confirmed they left at…",
  "يُكتب في سجلّ التعديلات وسجلّ النشاط باسمك. ولا يُقبل وقتٌ قبل الحضور ولا في المستقبل.": "Logged in the change and activity logs under your name. Times before check-in or in the future are not accepted.",
  "الاسم عربي": "Name (Arabic)",
  "الاسم إنجليزي": "Name (English)",
  "رقم الموظف": "Employee no.",
  "الرقم الوطني": "National ID",
  "الجنس": "Gender",
  "التواصل": "Contact",
  "الجوال": "Mobile",
  "عنوان البطاقة": "ID card address",
  "التوظيف": "Employment",
  "كود الوظيفة": "Job code",
  "القسم": "Department",
  "مكان العمل": "Workplace",
  "المدير المباشر": "Direct manager",
  "تاريخ الالتحاق": "Join date",
  "تاريخ الترك": "Leaving date",
  "نهاية الخدمة": "End of service",
  "سبب نهاية الخدمة": "End of service reason",
  "الراتب": "Salary",
  "الراتب الأساسي": "Base salary",
  "طريقة الصرف": "Payment method",
  "حساب الراتب": "Salary account",
  "بدل اجتماعي": "Social allowance",
  "بدل تأمين": "Insurance allowance",
  "مكافأة": "Bonus",
  "بدل مؤهل": "Qualification allowance",
  "راتب إضافي": "Extra salary",
  "إجمالي الإضافي": "Total overtime",
  "الرخصة": "License",
  "نوع الرخصة": "License type",
  "إصدار الرخصة": "License issue date",
  "بداية رخصة القيادة": "Driving license start",
  "نهاية رخصة القيادة": "Driving license end",
  "الجواز": "Passport",
  "نوع الجواز": "Passport type",
  "جنسية الجواز": "Passport nationality",
  "إصدار الجواز": "Passport issue date",
  "انتهاء الجواز": "Passport expiry",
  "حالة الجواز": "Passport status",
  "الإقامة": "Residency",
  "رقم الإقامة": "Residency no.",
  "نوع الإقامة": "Residency type",
  "حالة الإقامة": "Residency status",
  "إصدار الإقامة": "Residency issue date",
  "انتهاء الإقامة": "Residency expiry",
  "التأمين": "Insurance",
  "شركة التأمين": "Insurance company",
  "نوع التأمين": "Insurance type",
  "بداية التأمين": "Insurance start",
  "نهاية التأمين": "Insurance end",
  "انتهاء البطاقة الصحية": "Health card expiry",
  "الحضور والأجهزة": "Attendance & devices",
  "الحضور مفعّل": "Attendance enabled",
  "نمط الحضور": "Attendance mode",
  "آخر أيام إجازة": "Last leave days",
  "عمل قبل الإجازة": "Work before vacation",
  "قيمة يوم العمل": "Work day value",
  "سيريال الجهاز": "Device serial",
  "مدير النظام": "System admin",
  "الملف الكامل": "Full profile",
  "لا توجد بيانات HR من ERP لهذا الموظف — شغّل مزامنة الموظفين أولاً.": "No ERP HR data for this employee — run the employee sync first.",
  "الاسم مطلوب": "Name is required",
  "تعذّر الحفظ": "Couldn't save",
  "الرقم السري للموظف «{name}» — يدخل به التطبيق بكوده ({code}):": "PIN for employee \"{name}\" — used to log into the app with their code ({code}):",
  "الرقم السري 4 خانات على الأقل": "PIN must be at least 4 digits",
  "تم تعيين الرقم السري": "PIN set",
  "تعذّر": "Failed",
  "حذف الموظف «{name}» نهائياً مع سجلات حضوره؟": "Permanently delete employee \"{name}\" along with their attendance records?",
  "تعذّر الحذف": "Couldn't delete",
  "تمت — {n} موظف": "Done — {n} employees",
  "اكتملت مزامنة الموظفين من ERP": "Employee sync from ERP complete",
  "الإدارة الكاملة للموظف (البيانات + إعدادات الحضور + الرقم السري + سجل الحضور) صارت من صفحة": "Full employee management (data + attendance settings + PIN + attendance log) now lives on the",
  "هذي القائمة للعرض السريع.": "This list is for quick viewing.",
  "بحث بالاسم/الكود/الجوال": "Search by name/code/mobile",
  "موظف جديد": "New employee",
  "مزامنة الموظفين من ERP": "Sync employees from ERP",
  "الكود": "Code",
  "المسمى": "Title",
  "رقم سري ✓": "PIN ✓",
  "تعيين رقم سري": "Set PIN",
  "ملف HR": "HR profile",
  "لا يوجد موظفون — أضف واحدًا": "No employees — add one",
  "تعديل موظف": "Edit employee",
  "ربط بحساب الموظف في النظام (يسجّل حضوره بدخوله العادي)": "Link to the employee's system account (checks in with their normal login)",
  "الاسم الكامل *": "Full name *",
  "كود الموظف (اختياري)": "Employee code (optional)",
  "المسمى الوظيفي": "Job title",
  "بدون": "None",
  "تاريخ التعيين": "Hire date",
  "نوع الوردية": "Shift type",
  "8 ساعات": "8 hours",
  "12 ساعة": "12 hours",
  "مخصص": "Custom",
  "ساعات الوردية": "Shift hours",
  "بداية الدوام": "Shift start",
  "أيام العمل المطلوبة": "Required work days",
  "مكافأة شهرية": "Monthly bonus",
  "سعر الساعة الإضافية": "Overtime hourly rate",
  "كلمة سر جديدة (اختياري)": "New password (optional)",
  "كلمة سر دخول التطبيق": "App login password",
  "المتصفح لا يدعم تحديد الموقع": "Your browser doesn't support geolocation",
  "تعذّر تحديد الموقع": "Couldn't get location",
  "اسم الفرع مطلوب": "Branch name is required",
  "حذف هذا الفرع؟": "Delete this branch?",
  "فرع جديد": "New branch",
  "الإحداثيات": "Coordinates",
  "النطاق": "Radius",
  "مدير:": "Manager:",
  "لا توجد فروع — أضف واحدًا": "No branches — add one",
  "تعديل فرع": "Edit branch",
  "اسم الفرع *": "Branch name *",
  "خط العرض (Latitude)": "Latitude",
  "خط الطول (Longitude)": "Longitude",
  "نطاق الـ Geofence (متر)": "Geofence radius (m)",
  "مدير الفرع": "Branch manager",
  "جدول الدوام الأسبوعيّ": "Weekly work schedule",
  "يومُ الإجازة لا يُحسب فيه غياب، ومن يداومه يُحتسب حضورُه (وبدلُ الجمعة من إعدادات الرواتب). البداية والساعات هنا تتقدّمان على إعدادات الموظّف في ذلك اليوم؛ اتركهما فارغين ليُعمل بإعدادات الموظّف.": "A day off isn't counted as an absence, and anyone who works it gets attendance credit (Friday allowance comes from payroll settings). Start time and hours here override the employee's settings for that day; leave them blank to use the employee's settings.",
  "{n} يوم": "{n} days",
  "أرشيفُ الاستئذان غيرُ مقروءٍ لك — ليست لديك صلاحيتُها.": "You can't read the leave archive — you don't have that permission.",
  "تعذّرت قراءةُ أرشيف الاستئذان": "Couldn't read the leave archive",
  "فلا يُقال «لا توجد طلبات».": "so we can't say \"no requests\".",
  "أعد المحاولة": "Retry",
  "موافقة": "Approve",
  "لا توجد طلبات": "No requests",
  "جارٍ القراءة…": "Reading…",
  "الأرشيفُ غيرُ مقروءٍ الآن — انظر الرسالةَ أعلاه": "The archive can't be read right now — see the message above",
  "الموافقة على الطلب": "Approve request",
  "رفض الطلب": "Reject request",
  "ملاحظة للموظّف (اختياريّة)": "Note to employee (optional)",
  "موافق — عوّض الساعات الأربعاء": "Approved — make up the hours on Wednesday",
  "سبب الرفض": "Rejection reason",
  "يصل القرارُ إلى الموظّف في التطبيق فوراً، ويبقى في الأرشيف باسمك.": "The decision reaches the employee in the app immediately and stays in the archive under your name.",
  "تأكيد": "Confirm",
  "جارٍ الآن": "Running now",
  "احتسابٌ مكتمل": "Calculation complete",
  "ناقص — أخفق بعض الموظّفين": "Partial — some employees failed",
  "فاشل — لم يُحتسب أحد": "Failed — no one calculated",
  "انقطع — بقي موظّفون لم يُحاوَلوا": "Interrupted — some employees not attempted",
  "نتائج غير مؤكّدة": "Unconfirmed results",
  "متروك — مات قبل أن يكتمل": "Abandoned — died before completing",
  "لم يُحسم": "Undecided",
  "أخفق": "Failed",
  "غير مؤكّد": "Unconfirmed",
  "لم يُحاوَل": "Not attempted",
  "تعذّر قراءة حالة الاحتساب — الاعتماد موقوف حتى تُقرأ": "Couldn't read calculation status — approval is paused until it's read",
  "الاحتساب غير مكتمل": "Calculation incomplete",
  "تعذّر قراءة حالة الاحتساب": "Couldn't read calculation status",
  "أُنشئ {n}": "{n} created",
  "حُدِّث {n}": "{n} updated",
  "تُخطّي {n} (معتمَد/مدفوع)": "{n} skipped (approved/paid)",
  "أخفق {n}": "{n} failed",
  "لم يُحاوَل {n}": "{n} not attempted",
  "لم يُحتسب لهؤلاء (أرقام الملفّات): {ids} — صفوفُهم السابقة بقيت كما هي.": "Not calculated for these (profile IDs): {ids} — their previous rows were left unchanged.",
  "انقطع الاتصال أثناء الكتابة لهؤلاء: {ids} — قد تكون كُتبت أو لا. طابِق صفوفَهم قبل أيّ إعادة.": "Connection dropped while writing for these: {ids} — they may or may not have been written. Reconcile their rows before any retry.",
  "لم يُحاوَل هؤلاء إطلاقاً: {ids}.": "These were not attempted at all: {ids}.",
  "انقطع الاحتساب": "Calculation interrupted",
  "احتسابٌ ناقص": "Partial calculation",
  "الاحتساب جارٍ الآن": "Calculation is running now",
  "اقرأ الحالة أدناه.": "See the status below.",
  "تعذّر الاحتساب": "Calculation failed",
  "طابِق الصفوف المذكورة أدناه قبل أيّ إعادة احتساب.": "Reconcile the rows listed below before any recalculation.",
  "تعذّر تغيير الحالة": "Couldn't change status",
  "لا كشوفَ بانتظار الدفع": "No payslips awaiting payment",
  "لا مسودّاتِ في هذا الشهر": "No drafts this month",
  "شهر {m} لم ينتهِ بعد.": "Month {m} hasn't ended yet.",
  "الكشوفُ محسوبةٌ على راتبٍ كامل.": "Payslips are calculated on a full salary.",
  "تأكيد دفع {n} كشفاً لشهر {m}؟": "Confirm payment of {n} payslips for {m}?",
  "اعتماد {n} كشفاً لشهر {m}؟": "Approve {n} payslips for {m}?",
  "تأكيد دفع {n} كشفاً": "Payment confirmed for {n} payslips",
  "اعتماد {n} كشفاً": "{n} payslips approved",
  "صارت ظاهرةً للموظّفين في التطبيق": "Now visible to employees in the app",
  "تعذّر التأكيد دفع": "Couldn't confirm payment",
  "تعذّر الاعتماد": "Couldn't approve",
  "لا كشوفَ معتمدةً في هذا الشهر": "No approved payslips this month",
  "ردُّ {n} كشفاً لشهر {m} إلى «مسودّة»؟": "Revert {n} payslips for {m} to \"Draft\"?",
  "ستختفي من تطبيق الموظّفين.": "They will disappear from the employee app.",
  "رُدّ {n} كشفاً إلى مسودّة": "{n} payslips reverted to draft",
  "تعذّر الردّ": "Couldn't revert",
  "احتساب الرواتب": "Calculate payroll",
  "اعتماد الشهر كلّه ({n})": "Approve whole month ({n})",
  "تأكيد دفع الشهر ({n})": "Confirm month payment ({n})",
  "ردُّ الشهر إلى مسودّة ({n})": "Revert month to draft ({n})",
  "شهرٌ لم ينتهِ بعد": "Month not over yet",
  "تعذّر قراءة حالة الاحتساب — الاعتماد موقوف حتى تُقرأ.": "Couldn't read calculation status — approval is paused until it's read.",
  "أعد القراءة": "Reload",
  "لا يوجد احتساب مسجَّل": "No recorded calculation",
  "محاولة": "Attempt",
  "فوج {n}": "Cohort {n}",
  "تُخطّي {n}": "{n} skipped",
  "غير مؤكّد {n}": "{n} unconfirmed",
  "ملفّاتٌ تمنع الاعتماد:": "Profiles blocking approval:",
  "سجلٌّ ناقص:": "Missing schema:",
  "الأرقام أدناه قديمة.": "The numbers below are stale.",
  "آخرُ احتساب": "Last calculated",
  "وصلت {n} بصمةً بعده ولم تدخل الحساب.": "{n} check-ins arrived after it and weren't included.",
  "أعد الاحتساب": "Recalculate",
  "عدد الموظفين": "Employees",
  "الأساسي": "Base",
  "المكافآت": "Bonuses",
  "الخصومات": "Deductions",
  "بدل إجازة جمعة": "Friday allowance",
  "إضافي": "Overtime",
  "خصومات": "Deductions",
  "حضور/غياب": "Present/Absent",
  "الالتزام": "Compliance",
  "{n} جمعة": "{n} Fridays",
  "دقائقُ تجاوزت سقفَ الإضافيّ اليوميّ فلم تُحتسب. يُضبط السقفُ من «إعدادات الحضور والخصومات».": "Minutes over the daily overtime cap weren't counted. The cap is set under \"Attendance & deduction settings\".",
  "{n} د بالسقف": "{n} min capped",
  "أيّامٌ أسقطها استئذانٌ معتمَد من المطلوب": "Days removed from the requirement by approved leave",
  "وأُعفي {n} دقيقةَ تأخير": "{n} late minutes excused",
  "{n} بإذن": "{n} excused",
  "أيّامٌ بُصم فيها الحضور ولم يُبصم الانصراف — لا تُحتسب حضوراً. صحّحها من «سجلات الحضور».": "Days with a check-in but no check-out — not counted as attendance. Fix them from the attendance records.",
  "{n} بلا خروج": "{n} no check-out",
  "مسودة": "Draft",
  "تأكيد الدفع": "Confirm payment",
  "لا توجد رواتب — اضغط «احتساب الرواتب»": "No payroll — click \"Calculate payroll\"",
  "إنشاء تقرير": "Create report",
  "نوع التقرير": "Report type",
  "حضور تفصيلي (سجلات)": "Detailed attendance (records)",
  "ملخّص شهري (لكل موظف)": "Monthly summary (per employee)",
  "كشف الرواتب": "Payroll sheet",
  "أسبوعي (آخر 7 أيام)": "Weekly (last 7 days)",
  "نهاية الأسبوع": "Week ending",
  "الشهر": "Month",
  "يظهر اسم/شعار الشركة في رأس التقرير (يُضبط من الإعدادات).": "The company name/logo appears in the report header (set in Settings).",
  "تم حفظ الإعدادات": "Settings saved",
  "إعدادات الحضور والخصومات": "Attendance & Deduction Settings",
  "سماح التأخير (دقائق)": "Late grace (minutes)",
  "ساعات العمل القياسية": "Standard work hours",
  "خصم التأخير / دقيقة": "Late deduction / minute",
  "خصم الغياب / يوم": "Absence deduction / day",
  "خصم الخروج المبكر / دقيقة": "Early leave deduction / minute",
  "خصم الساعة الناقصة": "Missing hour deduction",
  "بدل إجازة الجمعة (د.ك لكل جمعة)": "Friday allowance (KWD per Friday)",
  "مهلة البصمة المفتوحة قبل أن تُهجَر (ساعات · ٠ = بلا هجر)": "Open check-in time limit before abandonment (hours · 0 = never)",
  "سقف الإضافي اليومي فوق المناوبة (ساعات · ٠ = لا إضافي · سالب = بلا سقف)": "Daily overtime cap above shift (hours · 0 = no overtime · negative = no cap)",
  "المكافأة تتطلب إكمال كل أيام العمل": "Bonus requires completing all work days",
  "اعتماد الحضور تلقائيًا داخل النطاق": "Auto-approve attendance inside the zone",
  "قيم الخصومات والبدلات محجوبة — تحتاج صلاحية «رواتب الموظفين». الحفظ من هنا لا يغيّرها.": "Deduction and allowance values are hidden — you need the \"Employee payroll\" permission. Saving here doesn't change them.",
  "لم تصل قيم الخصومات والبدلات من الخادم — أُخفيت ولن تُرسَل. الحفظ من هنا يغيّر الإعدادات التشغيلية فقط.": "Deduction and allowance values didn't arrive from the server — they're hidden and won't be sent. Saving here changes operational settings only.",
  "تمّت الموافقة": "Approved",
  "تمّ الرفض": "Rejected",
  "لم تُسلَّم": "Not delivered",
  "أعد الإرسال": "Resend",
  "تعذّرت إعادة الإرسال": "Couldn't resend",
  "نُسخ للحافظة": "Copied to clipboard",
  "أُعيد التوجيه إلى {name}": "Forwarded to {name}",
  "نسخ النص": "Copy text",
  "إعادة توجيه لمحادثة ثانية": "Forward to another conversation",
  "⤴ توجيه": "⤴ Forward",
  "إعادة توجيه إلى…": "Forward to…",
  "ابحث: اسم أو رقم…": "Search: name or number…",
  "لا محادثات مطابقة": "No matching conversations",
  "[مرفق]": "[attachment]",
};
export default EN_B1;
